import Installed from './Installed';

export default Installed;   